<div class=" scrollbar  longtab">
    <div class="">


        <ng-container *ngIf="taxDetails">
            <form [formGroup]="taxDetails">
                <div class="row">
                    <div class="col-3 af-form-group">
                        <label for="personnel"><span translate>lblPersonnelTax</span> (%) <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                            <input formControlName="personnel" class="form-control" id="personnel" type="text" maxlength="5" [ngClass]="{'is-invalid': (cpf.personnel.touched || cpf.personnel.dirty) && cpf.personnel.errors}" placeholder="Enter Personnel Tax Percentage">
                            <div *ngIf="(cpf.personnel.touched || cpf.personnel.dirty) && cpf.personnel.errors">
                                <div *ngIf="cpf.personnel.errors.required" class="help-block mt-1 text-danger" translate>
                                    lblPersonnelTaxRequired
                                </div>
                                <div *ngIf="cpf.personnel.errors.pattern" class="help-block mt-1 text-danger" translate>
                                    lblPersonnelTaxNotValidForPercentage
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 af-form-group" *ngIf="isMaterialTaxRequired">
                        <label for="material"><span translate>lblMaterialTax</span> (%) <span class="text-danger">*</span></label>
                        <div class="lbl-info">
                            <input formControlName="material" class="form-control" id="material" type="text" maxlength="5" [ngClass]="{'is-invalid': (cpf.material.touched || cpf.material.dirty) && cpf.material.errors}" placeholder="Enter Material Tax Percentage">
                            <div *ngIf="(cpf.material.touched || cpf.material.dirty) && cpf.material.errors">
                                <div *ngIf="cpf.material.errors.required" class="help-block mt-1 text-danger" translate>
                                    lblMaterialTaxRequired
                                </div>
                                <div *ngIf="cpf.material.errors.pattern" class="help-block mt-1 text-danger" translate>
                                    lblMaterialTaxNotValidForPercentage
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </ng-container>
    </div>
</div>
<div class="p-3 bg-light pp-footer-top-brdr" *ngIf="taxDetails">
  <div class="row">
    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb10 mt5">
        <button class="btn btn-primary btn-lg" (click)="onSaveChanges()" [disabled]="!taxDetails.valid" aria-label="Center Align" translate>lblSaveChanges</button>
        <a (click)="OnClose()" class="btn btn-secondary ml-2 btn-lg" translate>lblCancel</a>
    </div>
  </div>
</div>